import PageManipulationControls from './PageManipulationControlsContainer';

export default PageManipulationControls;